

import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AuthState } from "./auth.reducer";

//feature selector for auto completion
export const selectAuthState = createFeatureSelector<AuthState>("auth");


export const isLoggedIn = createSelector(
    selectAuthState,
    auth => !! auth?.authUser?.token
);

export const isLoggedOut = createSelector(
    isLoggedIn,
    loggedIn => !loggedIn
);